<p-dropdown placeholder="Selecione..." [filter]="true" appendTo="body" emptyFilterMessage="" dataKey="code"
   [options]="passengersNumber" [(ngModel)]="selectedPassengers" (onChange)="select($event)" optionLabel="label">
</p-dropdown>
